import React from 'react'
import ReactDOM from 'react-dom'
import Home from './templates/App'
import './index.css'

ReactDOM.render(
  <React.StrictMode>
    <Home />
  </React.StrictMode>,
  document.getElementById('root')
)
